import { createFileRoute } from '@tanstack/react-router';
import { ReviewListCard } from '@/features/cleaner/review-list-card';
import { HeaderDashboard } from '@/components/shared/header-dashboard';

export const Route = createFileRoute(
  '/(cleaner)/_authenticated/cleaner/reviews'
)({
  component: CleanerReviewsPage,
});

function CleanerReviewsPage() {
  return (
    <div>
      <HeaderDashboard>
        <HeaderDashboard.Title>Reviews</HeaderDashboard.Title>
      </HeaderDashboard>
      <div className="flex flex-col gap-4">
        <ReviewListCard />
      </div>
    </div>
  );
}
